import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as fileSaver from 'file-saver';

@Component({
  selector: 'app-import-dialog',
  templateUrl: './import-dialog.component.html',
  styleUrls: ['./import-dialog.component.scss'],
})
export class ImportDialogComponent {
  title: string;
  templateUrl: string;
  templateFileName: string;
  filesCtrl = new FormControl<any[]>([]);
  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<ImportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private http: HttpClient,
  ) {
    this.title = _data?.title || 'button.import';
    this.templateUrl = _data?.templateUrl || 'assets/templates/hos_casebase_template.xlsx';
    this.templateFileName = _data?.templateFileName || 'hos_casebase_template.xlsx';
  }

  isDragging = false;

  get files(): File[] {
    return this.filesCtrl.value || [];
  }

  onFileChange(eventOrFiles: any) {
    let files: File[] = [];
    if (eventOrFiles instanceof Event) {
      const target = eventOrFiles.target as HTMLInputElement;
      if (target.files) {
        files = Array.from(target.files);
      }
    } else if (Array.isArray(eventOrFiles)) {
      files = eventOrFiles; // Already an array of files (from drop)
    } else if (eventOrFiles instanceof FileList) {
      files = Array.from(eventOrFiles);
    }

    this.filesCtrl.setValue(files);
    this.isDragging = false;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      const files = Array.from(event.dataTransfer.files);
      this.onFileChange(files);
    }
  }

  removeFile(index: number) {
    const currentFiles = this.filesCtrl.value || [];
    currentFiles.splice(index, 1);
    this.filesCtrl.setValue([...currentFiles]);
  }

  downloadTemplate() {
    this.http
      .get(this.templateUrl, {
        responseType: 'blob',
      })
      .subscribe((blob) => {
        fileSaver.saveAs(blob, this.templateFileName);
      });
  }

  onConfirm() {
    const files = this.filesCtrl.value;
    if (files && files.length > 0) {
      this.dialogRef.close(files[0]);
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
